module.exports = __webpack_public_path__ + "img/image2.c8a71c78.png";